import io from "socket.io-client"; 
import React from "react";
export const socket = io('https://api.hpcfuelrite.com', { transports: ['websocket'] });
export const SocketContext = React.createContext();
